.iconSelectionContainer {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  height: auto;
}

.iconButton {
  border: 1px solid #e1e1e1;
  background-color: #fff;
  border-radius: 0;
  background-image: none;
  background-repeat: no-repeat;
  width: 50px;
  height: 50px;
}

.iconButton:disabled {
  background-color: #e6e6e6;
  opacity: 1;
}

.iconButton.active .icon {
  color: #006dce;
}

.icon {
  margin: 0;
  font-size: 25px;
  color: #444;
}
